
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetolonavalabushire() {



  const cardData =
  {
    keyword: ' Pune to Lonavala Bus Hire',
    heading: 'Vaishnavi Travels: Pune to Lonavala Bus Hire',
    headingDescription: 'Vaishnavi Travels provides affordable and reliable Pune to Lonavala Bus Hire, perfect for family picnics, school trips, corporate outings, and weekend getaways. Our buses are well-maintained with spacious seating, strong air-conditioning, and ample luggage space, ensuring a smooth and comfortable journey through the scenic Pune–Lonavala route. With professional drivers, timely pickups, and flexible booking options, we make group travel hassle-free and enjoyable. Whether it’s a leisure trip, religious yatra, or corporate retreat, Vaishnavi Travels guarantees safe, punctual, and convenient bus rental services from Pune to Lonavala.',

    top: 'Top Places to Visit in Lonavala with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is one of the most popular attractions in Lonavala, especially during the monsoon season. The overflowing waters create natural cascades where tourists enjoy splashing and relaxing. Surrounded by lush greenery and hills, it is a favorite picnic spot for families and friends. Vendors selling hot tea, corn, and pakoras add to the lively atmosphere. The scenic beauty and cool breezes make it a perfect rainy-season getaway. Bhushi Dam is Lonavala’s monsoon paradise of fun and nature."
  },
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap, also known as Tiger Point, is a cliff-top viewpoint offering breathtaking views of the valley below. The spot resembles a tiger leaping into the valley, hence the name. Tourists enjoy panoramic sights of lush hills, waterfalls, and winding roads. During monsoon, mist and clouds add a dreamy effect. Adventure lovers also try trekking and photography here. Tiger’s Leap is Lonavala’s most thrilling and scenic viewpoint."
  },
  {
    "title": "Karla Caves",
    "description": "The Karla Caves, dating back to the 2nd century BCE, are ancient Buddhist rock-cut caves near Lonavala. The grand Chaitya hall with intricately carved pillars and sculptures is a highlight. The caves reflect India’s rich Buddhist heritage and craftsmanship. Visitors also enjoy the serene surroundings and views from the hilltop. A nearby temple dedicated to Goddess Ekvira attracts pilgrims. Karla Caves are Lonavala’s timeless heritage and spiritual treasure."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake, also called Monsoon Lake, is a beautiful seasonal lake formed by the Indrayani River. It fills up during the rains, creating a serene retreat with lush greenery around. Locals and tourists enjoy picnics, photography, and peaceful walks by the water. Street stalls selling snacks make it lively during weekends. Birdwatchers also find it rewarding. Lonavala Lake is the town’s calm and scenic natural escape."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort, located near Lonavala, is a historic Maratha fort perched in the Sahyadris. Famous for its twin fortresses Shrivardhan and Manaranjan, it offers panoramic trekking trails. The fort is associated with the reign of Chhatrapati Shivaji Maharaj and narrates tales of Maratha bravery. Monsoon treks here are especially popular with waterfalls and misty valleys along the way. Camping enthusiasts also love the experience. Rajmachi Fort is Lonavala’s adventure and history hotspot."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort, about 15 km from Lonavala, is one of the most accessible trekking forts in Maharashtra. The ‘Iron Fort’ was used by Chhatrapati Shivaji Maharaj and has a rich history. Its famous ‘Vinchu Kata’ (scorpion’s tail) bastion offers incredible views of valleys and Pawna Lake. Trekkers and history lovers enjoy exploring its massive gates, ramparts, and steps. Monsoon makes the fort lush and scenic with clouds drifting around. Lohagad Fort is Lonavala’s blend of history, trekking, and natural charm."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake, an artificial reservoir near Lonavala, is famous for camping and outdoor activities. Surrounded by hills and forts like Tikona and Lohagad, it offers stunning sunset views. Tourists enjoy tent stays, bonfires, and water sports. The peaceful ambiance makes it perfect for couples, families, and adventure seekers. The reflection of the hills in the calm waters is breathtaking. Pawna Lake is Lonavala’s ultimate destination for camping and stargazing."
  },
  {
    "title": "Kune Waterfall",
    "description": "Kune Waterfall, located near Khandala in the Lonavala region, is one of Maharashtra’s highest waterfalls at 200 meters. Surrounded by lush greenery, the three-tiered fall looks spectacular in the monsoon. Tourists love its photogenic views and cool misty environment. It is a favorite stopover for nature lovers and families. The waterfall also offers opportunities for short hikes. Kune Waterfall is Lonavala’s refreshing natural wonder."
  },
  {
    "title": "Imagicaa Theme Park",
    "description": "Imagicaa, located near Lonavala, is India’s most famous theme park offering thrilling rides, water slides, and entertainment shows. It is perfect for families, kids, and adventure lovers seeking a fun-filled day. The park also has a snow world, food courts, and live performances. Its international-standard attractions make it a top destination for tourists. Easily accessible from Mumbai and Pune, it draws huge crowds year-round. Imagicaa is Lonavala’s hub of fun and excitement."
  },
  {
    "title": "Della Adventure Park",
    "description": "Della Adventure Park is India’s largest extreme adventure park, located in Lonavala. It offers over 50 activities including ATV rides, bungee jumping, zorbing, and paintball. Luxury resorts, restaurants, and cafés inside make it a complete leisure destination. Corporate groups, families, and thrill-seekers enjoy its unique offerings. The park combines adrenaline with luxury experiences. Della Adventure Park is Lonavala’s ultimate adventure and lifestyle hotspot."
  }
],

"services": [
  {
    "name": "Pune to Lonavala Bus Rental",
    "description": "Comfortable and reliable bus rental service from Pune to Lonavala, suitable for families, school groups, colleges, or corporate teams planning a short getaway. Our buses are available in multiple seating capacities including 25, 32, 40, and 50 seaters with both AC and Non-AC options. The route from Pune to Lonavala is scenic and our experienced drivers ensure a safe and pleasant journey with well-timed halts at popular viewpoints and eateries. Suitable for sightseeing, overnight trips, and day excursions to popular spots like Bhushi Dam, Tiger Point, Rajmachi Fort, and Wax Museum."
  },
  {
    "name": "One Day Trip Bus Pune to Lonavala",
    "description": "One-day tour bus service from Pune to Lonavala designed for quick escapes and group trips. Ideal for school excursions, college trips, family outings, or corporate leisure events. Includes early morning pickup from Pune, full-day sightseeing with customized stops, and return by evening. Our service includes clean buses, trained drivers, GPS-enabled tracking, onboard water bottles, and music systems for an enjoyable ride. Flexible packages available for 8 to 12-hour durations."
  },
  {
    "name": "AC Bus for Lonavala Travel",
    "description": "Premium AC buses for Pune to Lonavala travel ensuring a cool and relaxing ride throughout the journey. Ideal for summer trips, elderly travelers, or professional outings requiring higher comfort. Equipped with push-back seats, tinted windows, ambient lighting, and efficient air-conditioning. Suitable for weddings, business events, or family celebrations en route to Lonavala resorts or event venues. Extra features include onboard charging points and option to add refreshments on request."
  },
  {
    "name": "Non AC Bus Lonavala Tour",
    "description": "Budget-friendly Non-AC buses for Lonavala tours from Pune, ideal for short distances and groups that prioritize cost-effectiveness. These buses are well-maintained, spacious, and equipped with basic comforts like cushioned seating, fans, and ample luggage space. Best suited for school trips, college outings, or local community group tours during cooler seasons. Offers excellent value for day tours and local travel."
  },
  {
    "name": "Group Tour Bus to Lonavala",
    "description": "Dedicated group tour buses available from Pune to Lonavala for educational trips, community tours, wedding functions, or leisure getaways. Available in a variety of capacities (25 to 50 seaters) and customizable packages including multiple pickup points, scheduled sightseeing stops, and return trip. Includes driver coordination, time tracking, and optional tour guide services. A great option for large groups looking for safe, organized, and fun travel experiences."
  },
  {
    "name": "Weekend Getaway Bus Pune Lonavala",
    "description": "Weekend bus rentals from Pune to Lonavala curated for short getaways and staycations. Perfect for friends, families, or office teams looking for a relaxing weekend. Includes Friday night or Saturday early morning pickup, sightseeing, resort drop-offs, and Sunday evening return. Comfortable AC/Non-AC buses, customizable itineraries, and experienced drivers familiar with Lonavala’s routes and resort access points. Add-ons like music systems, refreshments, and decoration available."
  },
  {
    "name": "32/40 Seater Lonavala Bus",
    "description": "Spacious 32 or 40-seater buses for trips from Pune to Lonavala, suitable for medium to large groups. Ideal for school/college tours, corporate events, and family gatherings. These buses come with high headroom, reclining seats, wide windows for scenic views, and large luggage bays. Drivers are trained for hilly terrain and local sightseeing points. Options available for one-day or multi-day tours with overnight halts at hotels or resorts in Lonavala/Khandala."
  },
  {
    "name": "Family Trip Bus Hire Pune",
    "description": "Private bus hire service for families traveling from Pune to Lonavala for reunions, celebrations, or vacation trips. Offers flexible pickup/drop-off points, stopovers at attractions, and easy return planning. Vehicles include entertainment options like speakers and TV, and can be decorated for special occasions like birthdays or anniversaries. Clean and safe interiors suitable for kids, elders, and luggage for overnight stays. Peaceful and joyful journey for all age groups."
  },
  {
    "name": "School Picnic Bus Lonavala Pune",
    "description": "Safe and organized bus rental service for school picnics from Pune to Lonavala. Our buses follow strict safety protocols, are GPS tracked, and come with experienced, child-friendly drivers. Seating capacity from 25 to 50 students, with adequate space for bags, meals, and support staff. Stops include Lonavala Lake, Wax Museum, Bhushi Dam, and nature parks. Staff coordination and safety-first planning ensure a worry-free experience for teachers and organizers."
  },
  {
    "name": "Pune to Lonavala Road Trip Bus",
    "description": "Scenic road trip bus service from Pune to Lonavala for those looking to enjoy the route as much as the destination. Ideal for couples, youth groups, or photography tours. Includes stops at viewpoints, cafes, and hidden spots on request. Buses include panoramic windows, audio system, and flexible break options. Drivers know the best offbeat detours for a memorable road journey."
  },
  {
    "name": "Tourist Bus Hire Lonavala Trip",
    "description": "Tourist bus rentals for organized trips from Pune to Lonavala with itinerary planning included. Buses are licensed for tourist travel and come with route guidance, optional onboard tour guides, and arrangement for sightseeing stops such as Karla Caves, Lohagad Fort, Lion’s Point, and adventure parks. Packages available for corporate tourism, student educational trips, and NRIs visiting local spots. Comfortable, insured, and compliant with tourism norms."
  },
  {
    "name": "Budget Lonavala Bus from Pune",
    "description": "Affordable bus rental options from Pune to Lonavala catering to small groups or organizations with tight budgets. These include well-maintained non-AC vehicles or basic AC buses with essential features. Best suited for local clubs, budget school trips, small family gatherings, or religious group outings. Despite low pricing, our services never compromise on vehicle hygiene or driver professionalism. Rates available per hour or full-day use."
  },
  {
    "name": "Book Bus to Lonavala Online",
    "description": "Quick and easy online bus booking service for Pune to Lonavala travel. Choose from various bus types—AC, non-AC, 25 to 50 seaters—compare rates, view images, and confirm booking instantly. Our platform offers transparent pricing, digital invoices, route customization, and emergency support. Ideal for event planners, tourists, or individuals looking to skip the hassle of manual bus rental arrangements. 24/7 customer support and flexible cancellation policies also available."
  }
],
"tableData": [
  ["Pune to Lonavala Bus Rental", "One Day Trip Bus Pune to Lonavala"],
  ["AC Bus for Lonavala Travel", "Non AC Bus Lonavala Tour"],
  ["Group Tour Bus to Lonavala", "Weekend Getaway Bus Pune Lonavala"],
  ["32/40 Seater Lonavala Bus", "Family Trip Bus Hire Pune"],
  ["School Picnic Bus Lonavala Pune", "Pune to Lonavala Road Trip Bus"],
  ["Tourist Bus Hire Lonavala Trip", "Budget Lonavala Bus from Pune"],
  ["Book Bus to Lonavala Online"]
],




"whychoose": [
  {
    "WhyChooseheading": "Affordable Pune to Lonavala Bus Hire Service",
    "WhyChoosedescription": "Vaishnavi Travels offers budget-friendly and reliable bus hire services from Pune to Lonavala, perfect for weekend getaways and group travel."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Buses",
    "WhyChoosedescription": "Our buses feature cushioned seats and ample legroom to ensure a smooth and enjoyable journey to Lonavala."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly inspected, serviced, and thoroughly cleaned for optimal safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Packages for Day Trips or Overnight Stays",
    "WhyChoosedescription": "Choose hourly, full-day, or overnight rental options based on your travel needs and itinerary."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Lonavala Route",
    "WhyChoosedescription": "Our courteous drivers ensure safe and timely travel with complete knowledge of the Pune to Lonavala route and scenic stops."
  },
  {
    "WhyChooseheading": "Transparent Pricing – No Hidden Costs",
    "WhyChoosedescription": "Our all-inclusive pricing covers fuel, tolls, taxes, and driver allowances for a stress-free experience."
  },
  {
    "WhyChooseheading": "Perfect for Picnics, Corporate Trips, and Group Tours",
    "WhyChoosedescription": "Ideal for corporate outings, family getaways, school picnics, and leisure travel to Lonavala from Pune."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance and Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings and travel-related inquiries."
  }
]


























  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide bus hire services from Pune to Lonavala?',
      answer: 'Yes, Vaishnavi Travels offers reliable bus hire services from Pune to Lonavala, perfect for weekend getaways, group outings, corporate trips, and family vacations.',
    },
    {
      question: 'What types of buses are available for Pune to Lonavala trips?',
      answer: 'We provide a range of options including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, to cater to different group sizes and preferences.',
    },
    {
      question: 'What is the approximate cost for hiring a bus from Pune to Lonavala?',
      answer: 'Rental rates generally start from ₹5,000 for a one-day trip with a 32 seater tempo traveller. Prices vary based on bus type, duration, and additional services requested.',
    },
    {
      question: 'Are drivers included in the bus hire service?',
      answer: 'Yes, all our bus rentals come with experienced, licensed drivers familiar with the Pune-Lonavala route, ensuring safe and comfortable travel.',
    },
    {
      question: 'Can the itinerary be customized for the Lonavala trip?',
      answer: 'Absolutely. We tailor the schedule, stops, and timings to suit your group’s needs and preferences.',
    },
    {
      question: 'How far in advance should I book a bus from Pune to Lonavala?',
      answer: 'Booking at least 1-2 days in advance is recommended, especially during weekends and holiday seasons to ensure availability.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the rental fare?',
      answer: 'Tolls, parking fees, driver allowances, and permits are usually extra and will be clearly communicated during booking.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Aditya Kulkarni",
    position: "Corporate Event Manager",
    feedback:
      "We booked a 40 seater AC bus from Vaishnavi Travels for a corporate outing to Lonavala. The bus was spacious and clean, and the driver was professional and punctual. The whole experience was seamless and enjoyable.",
    rating: 5,
  },
  {
    name: "Mrs. Shweta Deshpande",
    position: "Family Trip Organizer",
    feedback:
      "Vaishnavi Travels provided excellent service for our family trip to Lonavala. The tempo traveller was comfortable and well-maintained, and the driver was courteous and knowledgeable about the route. Highly recommend their service.",
    rating: 5,
    style: "style-2",
  }
];


























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Bus Hire",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-lonavala-bus.jpg",
  "description": "Book Pune to Lonavala bus hire with Vaishnavi Travels for comfortable AC and Non AC buses ideal for day trips, weekend getaways, group tours, and family outings.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.77",
    "ratingCount": "1100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-lonavala-bus-hire"
  }
};



  return (
    <div>
<Helmet>
  <title>Pune to Lonavala Bus Hire | AC & Non AC Group Tours | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to Lonavala bus hire with Vaishnavi Travels for comfortable AC and Non AC buses ideal for day trips, weekend getaways, group tours, and family outings."
  />
  <meta
    name="keywords"
    content="Pune to Lonavala Bus Rental, One Day Trip Bus Pune to Lonavala, AC Bus for Lonavala Travel, Non AC Bus Lonavala Tour, Group Tour Bus to Lonavala, Weekend Getaway Bus Pune Lonavala, 32/40 Seater Lonavala Bus, Family Trip Bus Hire Pune, School Picnic Bus Lonavala Pune, Pune to Lonavala Road Trip Bus, Tourist Bus Hire Lonavala Trip, Budget Lonavala Bus from Pune, Book Bus to Lonavala Online"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolonavalabushire;